import ImagesConditionGuideConditionWebp from '@/public/images/condition-guide/condition.webp';
import ImagesConditionGuideExamplesPng from '@/public/images/condition-guide/examples.png';
import ImagesConditionGuideGreenTickSvg from '@/public/images/condition-guide/greenTick.svg';
import ImagesConditionGuideIcon2Png from '@/public/images/condition-guide/Icon2.png';
import ImagesConditionGuideIconPng from '@/public/images/condition-guide/icon.png';
import ImagesConditionGuideMagazineWebp from '@/public/images/condition-guide/magazine.webp';
import ImagesConditionGuideMainBannerWebp from '@/public/images/condition-guide/mainBanner.webp';
import ImagesConditionGuideNeckWebp from '@/public/images/condition-guide/neck.webp';
import ImagesConditionGuideNinelabelWebp from '@/public/images/condition-guide/ninelabel.webp';
import ImagesConditionGuideOriginalCapWebp from '@/public/images/condition-guide/original_cap.webp';
import ImagesConditionGuidePackagingWebp from '@/public/images/condition-guide/packaging.webp';
import ImagesConditionGuideSealWebp from '@/public/images/condition-guide/seal.webp';
import ImagesConditionGuideTagPng from '@/public/images/condition-guide/tag.png';
import ImagesConditionGuideWhiskeyfriendlyWebp from '@/public/images/condition-guide/whiskeyfriendly.webp';

export {
  ImagesConditionGuideConditionWebp,
  ImagesConditionGuideExamplesPng,
  ImagesConditionGuideGreenTickSvg,
  ImagesConditionGuideIcon2Png,
  ImagesConditionGuideIconPng,
  ImagesConditionGuideMagazineWebp,
  ImagesConditionGuideMainBannerWebp,
  ImagesConditionGuideNeckWebp,
  ImagesConditionGuideNinelabelWebp,
  ImagesConditionGuideOriginalCapWebp,
  ImagesConditionGuidePackagingWebp,
  ImagesConditionGuideSealWebp,
  ImagesConditionGuideTagPng,
  ImagesConditionGuideWhiskeyfriendlyWebp,
};
